// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__QK80t","tyre":"style_tyre__3MZ7Q"};